import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 




const styles = StyleSheet.create({
     
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
          
        
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, // space between bullet points
          },
          bulletSymbol: {
            width: 10, // fixed width for bullet
            fontSize: 10,
            marginRight: 5, // gap between bullet and text
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          


        });


        
        
const Form6P2S1 = ({ result }) => {

    const tableData = [
        ['1', 'Total period of qualifying service which has been accepted for the grant of superannuation or Retiring or Invalid or Compensation or Compassionate Pension and gratuity with  reasons for disallowance, if any  ( other than disallowance indicated in Part I of this Form ).'
            , `${result.calculation[0].pensionableService.years} Years ${result.calculation[0].pensionableService.months} Months ${result.calculation[0].pensionableService.days} Days`],
        ['2', `Amount of Superannuation or Retiring or Invalid or Compassionate Pension or gratuity that has been admitted.`,'not authorised'],
        ['3', `The date from which superannuation Retiring or Invalid Compensation or Compassionate Pension or gratuity is admissible.`,
          result?.dateOfRetirement
          ? (() => {
              const [d, m, y] = result.dateOfRetirement.split('/').map(Number);
              const date = new Date(y, m - 1, d);
              date.setDate(date.getDate() + 1);
              return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
            })()
          : 'N/A'
       ],
        ['4', 'Head of Account to which Superannuation or Retiring or Invalid or Compensation or Compassionate Pension or gratuity is Chargeable.', `Retirement benefit (J & D) State Aided approved Schools/colleges`],
        ['5', 'The account of the Family Pension, 1964 becoming payable to the entitled members of the family in the event of death of the Government servant after retirement’', ''],
      ];
      
  
  return (
              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.ArialBold]}>PART II</Text>
                <Text style={[style.subtitle, { fontSize: 10 }]}>Section I</Text>
                <Text style={[style.title, style.ArialBold]}>
                AUDIT ENFACEMENT:
                </Text>

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>

              <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}, {textAlign: 'right'}, {marginTop: 80}]}>Head of Office</Text>

        
              </View>

);
};

export default Form6P2S1;